
let model = {}

model.dataForm = {
    id: undefined,
    title: undefined,
    file_id: undefined,
    description: undefined
}
model.tableRules = {
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: false,
    total: 0,
    page: 1,
    limit: 20,
    offset: 0,
    sort: "title",
    defaultSort: ["title","ascending"],
    fields: "id,title,file_id,description",
    dataSearch: {
        value: {
            title: "",
            description: ""
        },
        operator: {
            title: ":regex_i:",
            description: ":regex_i:"
        },
    }
}

export default model